/* Billy hero video: attach the right-sized MP4 after page load so the poster image
   wins LCP, skip it for reduced-motion / data-saver, and pause it off-screen. */
(() => {
  if (window.billyHeroInit) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = navigator.connection && navigator.connection.saveData;
  const desktop = window.matchMedia('(min-width: 750px)');

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (!target.src) return;
          if (isIntersecting) target.play().catch(() => {});
          else target.pause();
        });
      })
    : null;

  const start = () => {
    if (reduce.matches || saveData) return;
    document.querySelectorAll('[data-billy-hero-video]').forEach((video) => {
      if (video.src) return;
      const src = desktop.matches ? video.dataset.srcDesktop : video.dataset.srcMobile;
      if (!src) return;
      video.muted = true;
      video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
      video.src = src;
      if (observer) observer.observe(video);
      video.play().catch(() => {});
    });
  };

  const later = () => ('requestIdleCallback' in window ? requestIdleCallback(start, { timeout: 1500 }) : setTimeout(start, 200));

  if (document.readyState === 'complete') later();
  else window.addEventListener('load', later, { once: true });

  document.addEventListener('shopify:section:load', start);
  window.billyHeroInit = true;
})();
